import React from "react";
import { CONDITION_LABELS } from "./ohsConstants";
import { ConditionBadge, ConditionBadgeRow } from "./Ohs.styles";

/**
 * Every status a box or item has, one badge each (e.g. Low and Expired side by side).
 * @param {Object} props
 * @param {Array<string>} props.statuses Condition keys, worst first.
 */
function ConditionBadges({ statuses }) {
    return (
        <ConditionBadgeRow>
            {statuses.map((conditionStatus) => (
                <ConditionBadge key={conditionStatus} $condition={conditionStatus}>
                    {CONDITION_LABELS[conditionStatus]}
                </ConditionBadge>
            ))}
        </ConditionBadgeRow>
    );
}

export default ConditionBadges;
